import { Button, ButtonProps, styled } from '@mui/material';
import { ReactNode } from 'react';

const StyledButton = styled(Button, {
  name: 'StyledButton',
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{
  isActive: boolean;
}>(({ theme, isActive }) => ({
  padding: theme.spacing(0.5),
  minWidth: '1rem',
  color: 'inherit',
  backgroundColor: isActive ? theme.palette.custom.OV.sys.tertiaryContainer : 'none',

  '&:active, &:hover': {
    backgroundColor: theme.palette.custom.OV.sys.tertiaryContainer,
  },
}));

type EditorToolbarButtonProps = {
  children: ReactNode;
  isActive?: boolean;
} & ButtonProps;

export const EditorToolbarButton = ({
  children,
  isActive = false,
  ...rest
}: EditorToolbarButtonProps) => {
  return (
    <StyledButton isActive={isActive} variant={isActive ? 'contained' : 'text'} {...rest}>
      {children}
    </StyledButton>
  );
};
